module.exports = __webpack_public_path__ + "img/event_teacher_error.6ee353b5.svg";